module.exports = __webpack_public_path__ + "static/media/img88.58ea2413.jpg";